/**
 * 모바일 기기 판별(specs/037 R-002) — 좁은 화면 + 거친 포인터(터치)일 때만 모바일로 본다.
 * User-Agent 는 태블릿·데스크톱 모드에서 오판이 잦아 쓰지 않는다. matchMedia 가 없는 환경(테스트·구형)은 데스크톱으로 본다.
 */
const MOBILE_QUERY = '(max-width: 767px) and (pointer: coarse)';

function mobileQueryList(): MediaQueryList | undefined {
  return typeof window === 'undefined' ? undefined : window.matchMedia?.(MOBILE_QUERY);
}

export function isMobileDevice(): boolean {
  return !!mobileQueryList()?.matches;
}

/** 판별 결과 변화(회전·창 크기) 구독 — `useIsMobileDevice` 의 useSyncExternalStore 원천. */
export function subscribeMobileDevice(onChange: () => void): () => void {
  const list = mobileQueryList();
  list?.addEventListener('change', onChange);
  return () => list?.removeEventListener('change', onChange);
}

/** 카카오톡 인앱 브라우저 — 파일 선택·촬영이 불안정할 수 있어 기본 브라우저 안내를 띄운다(spec Edge Case). */
export function isKakaoInAppBrowser(): boolean {
  return typeof navigator !== 'undefined' && /KAKAOTALK/i.test(navigator.userAgent);
}
